import { Button as EdgeFooterButton, Link } from '@bfa/base-ui';
import { Box } from '@bfa/common-ui';
import React from 'react';
import { Container } from './EdgeCTA.styled';
var EdgeCTA = function (_a) {
    var edgeButtonText = _a.edgeButtonText, onEdgeButtonClick = _a.onEdgeButtonClick, edgeLinkText = _a.edgeLinkText, onEdgeLinkClick = _a.onEdgeLinkClick, isMobile = _a.isMobile;
    return (React.createElement(Container, { edgeLinkText: edgeLinkText, isMobile: isMobile },
        React.createElement(EdgeFooterButton, { small: true, variant: "primary", onClick: onEdgeButtonClick }, edgeButtonText),
        edgeLinkText && (React.createElement(Box, { pt: ['1rem', '1.6rem'], pb: ['1rem', '1.6rem'] },
            React.createElement(Link, { variant: "secondary", onClick: onEdgeLinkClick, small: true }, edgeLinkText)))));
};
export default EdgeCTA;
